var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"px-3 mb-3"},[_c('router-link',{staticClass:"font-bold underline",attrs:{"to":"/"}},[_vm._v("Back to Home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }